import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import styled, { StyleSheetManager } from 'styled-components';
import { PageLoading } from 'components/atoms/loading';
import { useAgentBuilderHostAPI } from 'hooks/use-agent-builder-host-api';
import { isNitroClawShell } from 'utils/app-shell-mode';
const NitroBrewApp = /*#__PURE__*/ React.lazy(()=>import('agentBuilder/NitroBrewApp').then((module)=>({
            default: module.NitroBrewApp
        })));
const NitroBrewWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
export const NitroBrewRemote = ()=>{
    const hostAPI = useAgentBuilderHostAPI();
    const flushDesktop = isNitroClawShell();
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
        children: /*#__PURE__*/ _jsx(StyleSheetManager, {
            target: document.head,
            children: /*#__PURE__*/ _jsx(NitroBrewWrapper, {
                className: flushDesktop ? undefined : 'cp-pt-2 cp-pb-2 cp-pl-0 cp-pr-2',
                children: /*#__PURE__*/ _jsx(NitroBrewApp, {
                    hostAPI: hostAPI
                })
            })
        })
    });
};
